export default "__VITE_ASSET__DBMzcwV7__"